import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 36, className = "", ...rest }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionTag({ children, dark = true }) {
  return (
    <span
      className={`inline-flex items-center gap-3 text-xs uppercase tracking-[0.28em] font-semibold ${
        dark ? "text-gold" : "text-gold-deep"
      }`}
    >
      <span className={`h-px w-8 ${dark ? "bg-gold" : "bg-gold-deep"}`} />
      {children}
    </span>
  );
}

export function Counter({ to, format, duration = 2.2, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const reduce = useReducedMotion();
  const [val, setVal] = useState(reduce ? to : 0);

  useEffect(() => {
    if (!inView || reduce) return;
    const controls = animate(0, to, {
      duration,
      ease: EASE,
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, to, duration, reduce]);

  const fmt = format || ((v) => Math.round(v).toLocaleString("pt-BR"));
  return (
    <span ref={ref} className={className}>
      {fmt(val)}
    </span>
  );
}

export function LogoMark({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#090B0E" />
      <rect width="64" height="64" rx="14" fill="none" stroke="#E9B83F" strokeOpacity="0.35" />
      <path
        d="M10 34h10l5-14 8 26 6-18 4 6h11"
        fill="none"
        stroke="#E9B83F"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
